import toggleModal from '@/scripts/utils/toggle-modal';
import { DOCUMENT_ELEMENT } from '@/scripts/constants';
import './VideoModal.scss';

export default class VideoModal {
  constructor(props) {
    this.triggerElements = props.triggerElements;
    if (!this.triggerElements.length) return;
    this.modal = document.querySelector('[data-role*="video-modal-element"]');
    this.modalContent = this.modal.querySelector('[data-role*="video-modal-content"]');
    this.closeElement = this.modal.querySelector('[data-role*="video-modal-close"]');

    this.init();
  }

  toggleStatus(allow) {
    DOCUMENT_ELEMENT.classList.toggle('video-modal-opened', allow);
    return toggleModal(
      allow,
      null,
      this.modal,
    );
  }

  initModal(el) {
    const { params } = el.dataset;
    const {
      type, url, data, copyContentToModal,
    } = JSON.parse(params);
    this.toggleStatus(true);
    if (copyContentToModal) {
      $(this.modalContent).append($(el).find('[data-role*="content-to-fill-modal"]').html());
    } else {
      this.modal.classList.add('is-loading');
      $.ajax({
        type,
        url,
        data,
        success: (result) => {
          $(this.modalContent).append(result);
          const $video = $(this.modalContent).find('video');
          $video.on('canplay', () => {
            $video[0].play();
            this.modal.classList.remove('is-loading');
          });
        },
      });
    }
  }

  destroyModal() {
    this.toggleStatus(false);
    this.modal.addEventListener('transitionend', () => {
      $(this.modalContent).children().remove();
    }, { once: true });
  }

  init() {
    Array.from(this.triggerElements).forEach((el) => {
      el.addEventListener('click', () => {
        this.initModal(el);
      });
    });
    this.closeElement.addEventListener('click', () => {
      this.destroyModal();
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/lib/VideoModal/VideoModal.js



// WEBPACK FOOTER //
// ./scripts/lib/VideoModal/VideoModal.js